module.exports = __webpack_public_path__ + "img/qualizy-badge-dark.a42db41c.svg";